import React from 'react'

function PageHeader() {
    return (
        <div className="container">
            <div className="mainheading">
                <h1 className="sitetitle">Mediumish</h1>
                <p className="lead">
                    Bootstrap theme, medium style, simply perfect for bloggers
                </p>
            </div>
        </div>
    )
}

export default PageHeader
